const domains = [
  {
    id: 'architecture',
    label: '01',
    title: 'System Architecture',
    subtitle: 'Scalable, modular design with clear boundaries',
    description:
      'We architect systems that stand the test of time. Every component serves a clear purpose, every interface is intentional, and every boundary is drawn with long-term evolution in mind.',
    bgClass: 'bg-background-50',
    accentClass: 'text-primary-500',
  },
  {
    id: 'quality',
    label: '02',
    title: 'Clean Code & Quality',
    subtitle: 'Rigorous standards for maintainable codebases',
    description:
      'Quality is not negotiable. We enforce disciplined coding standards, thorough testing practices, and systematic review processes that ensure every line of code is intentional and every module is testable.',
    bgClass: 'bg-background-100',
    accentClass: 'text-accent-500',
  },
  {
    id: 'usability',
    label: '03',
    title: 'Usability & Design',
    subtitle: 'Interfaces shaped by human behavior',
    description:
      'We design for the people who will use the software every day. Our human-centered process combines research, prototyping, and iterative refinement to create interfaces that are intuitive, efficient, and enjoyable.',
    bgClass: 'bg-background-50',
    accentClass: 'text-secondary-400',
  },
];

export default function ExpertiseSection() {
  return (
    <section className="w-full">
      {domains.map((domain) => (
        <div key={domain.id} className={`w-full ${domain.bgClass}`}>
          <div className="max-w-[1440px] mx-auto px-6 md:px-12 lg:px-20 py-20 md:py-28">
            <div className="flex flex-col lg:flex-row lg:items-start gap-8 lg:gap-20">
              {/* Left: label + title */}
              <div className="lg:w-1/2">
                <span className="block font-label text-xs text-foreground-400 tracking-widest uppercase mb-5">
                  {domain.label}
                </span>
                <h3 className={`font-heading text-3xl md:text-4xl lg:text-5xl font-bold ${domain.accentClass} leading-[1.1] tracking-tight mb-3`}>
                  {domain.title}
                </h3>
                <p className="text-base md:text-lg text-foreground-200 font-medium leading-snug">
                  {domain.subtitle}
                </p>
              </div>

              {/* Right: description */}
              <div className="lg:w-1/2 lg:pt-2">
                <p className="text-sm md:text-base text-foreground-400 leading-relaxed max-w-lg">
                  {domain.description}
                </p>
              </div>
            </div>
          </div>

          {/* Separator between sections */}
          {domain.id !== 'usability' && (
            <div className="max-w-[1440px] mx-auto px-6 md:px-12 lg:px-20">
              <div className="w-full h-px bg-foreground-50/6"></div>
            </div>
          )}
        </div>
      ))}
    </section>
  );
}